import { render, staticRenderFns } from "./question.component.html?vue&type=template&id=76122697&scoped=true&external"
import script from "./question.component.ts?vue&type=script&lang=ts&external"
export * from "./question.component.ts?vue&type=script&lang=ts&external"
import style0 from "./question.component.scss?vue&type=style&index=0&id=76122697&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76122697",
  null
  
)

export default component.exports